/**
 *
 * Accessibility Greyscale Filter (Webseite in Grau darstellen)
 *
 * Accessibility Greyscale Filter fügt eine Funktion zur Schwarz/Weiß Darstellung der Webseite hinzu. Die
 * Eingabe wird im Cookie zwischengespeichert, bis der Benutzer den Browser/Session schliesst.
 *
 * Event: document.ready
 *
 * @param {string} selector - Selector für den Button
 * @param {string} selectorWrapper - Selector Wrapper für den Button
 * @return {undefined}
 *
 *
 **/
function nc_initAccessibilityGreyscaleFilter(selector, selectorWrapper) {
    var moduleLogger = LoggerManager.get('greycale-filter').setPrefix('Selector: ' + selector + 'Selector Wrapper: ' + selectorWrapper);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_accessibilityGreyscaleFilter(selector, selectorWrapper);
    });
    moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initAccessibilityGreyscaleFilter
 * @param selector {string}
 * @param selectorWrapper {string}
 */
function nc_accessibilityGreyscaleFilter(selector, selectorWrapper) {
    /**
     * Logger
     */
    var moduleLogger = LoggerManager.get('greycale-filter').setPrefix('Selector: ' + selector + 'Selector Wrapper: ' + selectorWrapper);
    moduleLogger.trace('SCRIPT START');


    /**
     * Button für Greyscale
     */
    $(selector).click(function () {
        /**
         * Klasse die im HTML beim klick gesetzt wird
         */
        $("html").toggleClass("greyscale-filter");

        /**
         * Klasse die im ICON beim klick gesetzt wird
         */
        $(selectorWrapper).toggleClass("is-active");

        /**
         * Cookies setzen oder entfernen
         */
        if ($("html").hasClass("greyscale-filter")){
            $.cookie("NC_Theme_ContrastMode", 1, { expires : 1, path: '/' });
        } else {
            $.cookie("NC_Theme_ContrastMode", null, { path: '/' });
        }
    });

    /**
     * Cookieabfrage
     */
    function checkCookieValues(){
        if ($.cookie('NC_Theme_ContrastMode')==1) {

            /**
             * Cookie ist gesetzt, klassen werden hinzugefügt
             */
            $("html").toggleClass("greyscale-filter");
            $(selectorWrapper).toggleClass("is-active");
        }
    }

    /**
     * Funktion zur Cookieabfrage ausführen
     */
    checkCookieValues();

    moduleLogger.info('SCRIPT ENDE');

}
